import { userService } from "../services";
import { router } from "../helpers";

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
                router.push("/login");
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return Promise.resolve(data);
    });
}

export function handleResponseLogin(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            if (response.status === 422) {
                const error = (data && data.error_msg) || response.statusText;
                return Promise.reject(error);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
